"use client";

import styles from './index.module.scss';
import Accordion from "@/app/_components/Shared/Accordion";
import TextInput from "@/app/_components/Shared/TextInput";
import SearchIcon from "@/app/icons/search.svg";
import {useCallback, useMemo, useState} from "react";

export default function Faq({
    data,
    title = "FAQ",
    withSearch = false,
}) {
    const [search, setSearch] = useState("");

    const handleSearch = useCallback((e) => {
        setSearch(e.target.value);
    }, [setSearch]);

    const filteredData = useMemo(() => {
        if (!search) {
            return data;
        }
        return data.filter(item => item.title.toLowerCase().includes(search.toLowerCase()) || item.content.toLowerCase().includes(search.toLowerCase()));
    }, [data, search]);

    if (!data.length) return null;
    return (
        <div className={styles.faq}>
            {
                withSearch && <TextInput value={search} onChange={handleSearch} icon={SearchIcon}
                                         placeholder="Search for the topics..."/>
            }
            {
                title &&
                <h1 className={styles.title}>
                    {title}
                </h1>
            }
            <div className={styles.content}>
                {filteredData.map((item, index) => (
                    <Accordion key={index} title={item.title} defaultShow={!index}>
                        {item.content}
                    </Accordion>
                ))}
            </div>
        </div>
    );
}